import Button from '@components/v2/ui/Button/Button';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import { LucideIcon } from 'lucide-react';
import { memo } from 'react';
import { isTouchEnabled } from '../../../../../../Theme';
import useWidth from '../../../../../../components/Hooks/useWidth';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { getOrderSummaryActionButtonStyles } from './orderSummaryActions.styles';

interface OrderSummaryActionButtonProps {
  label: LangEnum;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  ActionIcon?: LucideIcon;
  disabled?: boolean;
  testId?: string;
}

const OrderSummaryActionButton = ({
  label,
  onClick,
  ActionIcon,
  disabled,
  testId,
}: OrderSummaryActionButtonProps) => {
  const { translate } = useTranslation();
  const { largeWidthUp } = useWidth();

  const shape = isTouchEnabled ? 'square' : 'round';

  if (!largeWidthUp && ActionIcon) {
    return (
      <IconButton
        icon={ActionIcon}
        shape={shape}
        disabled={disabled}
        testId={testId}
        ariaLabel={translate(label)}
        sx={(theme) => ({ ...getOrderSummaryActionButtonStyles(theme) })}
        onClick={onClick}
      />
    );
  }

  return (
    <Button
      variant="text"
      color="secondary"
      shape={shape}
      disabled={disabled}
      testId={testId}
      startIcon={ActionIcon ? <ActionIcon /> : undefined}
      sx={(theme) => ({ ...getOrderSummaryActionButtonStyles(theme) })}
      onClick={onClick}
    >
      {translate(label)}
    </Button>
  );
};

export default memo(OrderSummaryActionButton);
